import { colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupPresentationProps, CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import { IconWrapper } from "@insite/mobius/Icon";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const checkbox: RecursivePartial<{
    defaultProps?: CheckboxPresentationProps | undefined;
    groupDefaultProps?:
        | (FieldSetGroupPresentationProps<CheckboxGroupProps> & CheckboxGroupPresentationProps)
        | undefined;
}> = {
    defaultProps: {
        color: colorStrings.commonGlobalWhite,
        indeterminateColor: colorStrings.commonGlobalWhite,
        mergeCss: true,
        css: css`
            ${IconWrapper} {
                &[role="checkbox"] {
                    border-radius: 0;
                    border: 1px solid ${getColor(colorStrings.commonGlobalGray01)};
                    margin: 0 0 1px;
                    width: 20px;
                    height: 20px;

                    &[aria-checked="true"],
                    &[aria-checked="mixed"] {
                        &:not([aria-disabled="true"]) {
                            border: 1px solid ${getColor(colorStrings.secondaryMain)};
                            background-color: ${getColor(colorStrings.commonGlobalWhite)};
                            color: ${getColor(colorStrings.secondaryMain)};

                            svg {
                                width: 20px;
                                height: 20px;
                            }
                        }

                        & + label {
                            color: ${getColor(colorStrings.primaryMain)};
                            font-weight: 700;
                        }
                    }

                    &[aria-disabled="true"] {
                        background-color: ${getColor(colorStrings.commonGlobalWhite)};
                        border-color: ${getColor(colorStrings.commonGlobalGray04)};

                        & + label {
                            color: ${getColor(colorStrings.commonGlobalGray04)};
                        }
                    }
                }
            }

            label {
                font-size: 14px;
                line-height: normal;
            }
        `,
    },
};
